import type { HTMLAttributes } from 'react'
import { cx } from '@/lib/cx'
import styles from './VisuallyHidden.module.css'

/** Elements {@link VisuallyHidden} can render as. */
export type VisuallyHiddenElement = 'span' | 'div' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'strong'

/** Props for {@link VisuallyHidden}. */
export interface VisuallyHiddenProps extends HTMLAttributes<HTMLElement> {
  /** Element to render. Default `'span'`. */
  as?: VisuallyHiddenElement
}

/**
 * Content for screen readers only. It stays in the accessibility tree but is invisible.
 *
 * @example <VisuallyHidden as="h2">How it works</VisuallyHidden>
 */
export function VisuallyHidden({ as: Tag = 'span', className, ...rest }: VisuallyHiddenProps) {
  return <Tag className={cx(styles.root, className)} {...rest} />
}
